import React, { useEffect, useLayoutEffect, useState } from 'react';
import { logError } from "../utils/builder/IAmecLog";
import { cloneDeep, isNull } from 'lodash';
import toast from "react-hot-toast";
import Toast from "../components/Toasts/Toast";
import ManagerToast from "../components/Toasts/ManagerToast";
import { subscriptionType } from "./data";
import { valueTypes } from './builder/ResultClasses';
import { colorSchemeType, columnDataType, conditionTabId, conditionsType } from './types';
import { COLOR_PALETTE } from './colorPalette/colorPalette';
import { conditionTypes } from './builder/TemplatesAndCollections';
import { ItemsTypeEnum, initTemplateSettings, initTemporarySetting } from 'store/reducers/viewerReducer';
import { propertyInfo } from './builder/IScheduleLogic';
import { parse, compareAsc, compareDesc } from 'date-fns';

import { getBounding } from "utils/elementExt";

export const updateFilters = (res) => {
  const deepCopy = cloneDeep(res);

  for (const key in deepCopy) {
    if (!deepCopy[key]) {
      delete deepCopy[key]
    }
  }

  return deepCopy;
};

//   items filtering by search
export const searchByText = (list, value) => {
  if (!value) {
    return list;
  }
  const newlist = list.filter((el) => {
    if (typeof el === "string") {
      return el.toLowerCase().includes(value.toLowerCase());
    }
    return (
      el.text.toLowerCase().includes(value.toLowerCase()) ||
      el.type.toString().includes(value.toString())
    );
  });
  return newlist;
};
//  table items filtering by search
export const searchBy = (arr, value) => {
  if (!value) {
    return arr;
  }
  return arr.filter((list) => {
    const condition = list.find((el) => {
      if (typeof el === "string") {
        return el.toLowerCase().includes(value.toLowerCase());
      }
      return value.toLowerCase() == el;
    });
    return condition;
  });
};

export const searchInlines = (arr, value) => {
  if (!value) {
    return arr;
  }

  return arr.filter(({ lines }) => {
    const condition = Object.values(lines).find((el) => {
      return String(el).toLowerCase().includes(value.toLowerCase());
      // if (typeof el === "string") {
      //   return el.toLowerCase().includes(value.toLowerCase());
      // }

      // return value.toLowerCase() == el;
    });

    return condition;
  });
};

export const toArray = (obj) => {
  let arr = [];
  for (const key in obj) {
    arr = [...arr, ...obj[key]];
  }
  return arr;
};

// tree  state saving & searching
const setFun = (list) => {
  let tempObj = {};
  list.map((el) => (tempObj[el.id] = {}));
  return tempObj;
};

export const treeAdd = (object, value, list, condition, level) => {
  if (level === 1) {
    return { ...object, [value]: condition ? setFun(list) : {} };
  }
  if (Object.keys(object).length === 0) {
    object = condition ? { [value]: setFun(list) } : {};
  } else {
    for (const key in object) {
      if (value === key) {
        object[value] = condition ? setFun(list) : {};
        return object;
      }
    }

    for (const key in object) {
      treeAdd(object[key], value, list, condition);
    }
  }

  return object;
};
//
export let searchTreeCondition = false;

export const searchTreeFun = (tree, id) => {
  let condition = false;

  const bodyFun = (tree, id) => {
    if (Object.keys(tree).length !== 0) {
      for (const key in tree) {
        if (id === key) {
          if (Object.keys(tree[key]).length !== 0) {
            return (condition = true);
          }
        }
      }
      for (const key in tree) {
        bodyFun(tree[key], id);
      }
    }
    return condition;
  };
  return bodyFun(tree, id);
};

export const searchLevel = async (value, getNextLevel, id) => {
  let condition;
  try {
    let list = await getNextLevel(id);
    if (!value) {
      return {
        list,
        condition: false,
      };
    }
    const newList = list.filter((el) => {
      const elCondition = el.text.toLowerCase().includes(value.toLowerCase());
      if (elCondition) {
        condition = true;
      }
      return elCondition;
    });
    return {
      list: newList,
      condition: condition,
    };
  } catch (err) {
    logError("FrontEnd.src.utils.helper.searchLevel", err.toString());
  }
};

export const findFoldersTreeObj = (id, treeItem) => {
  if (Array.isArray(treeItem)) {
    const idIndex = treeItem.findIndex(item => item.id == id);

    if (idIndex >= 0) {
      return treeItem[idIndex];
    } else {
      let obj = null;

      treeItem.some(treeArrItem => {
        const reqObj = findFoldersTreeObj(id, treeArrItem);

        if (reqObj) {
          obj = reqObj;
        }
      });

      return obj;
    }
  } else {
    if (treeItem.hasOwnProperty('childrenArr')) {
      const reqObj = findFoldersTreeObj(id, treeItem.childrenArr);

      if (reqObj) {
        return reqObj;
      }
    }
  }
};

export const getFoldersBreadcrumbs = (id, treeItem) => {
  if (Array.isArray(treeItem)) {
    const idIndex = treeItem.findIndex(item => item.id == id);

    if (idIndex >= 0) {
      return [treeItem[idIndex]];
    } else {
      let arr = null;

      treeItem.some(treeArrItem => {
        const reqArr = getFoldersBreadcrumbs(id, treeArrItem);

        if (reqArr?.length) {
          arr = [treeArrItem, ...reqArr];
        }
      });

      if (arr?.length) {
        return arr;
      }
    }
  } else {
    if (treeItem.hasOwnProperty('childrenArr')) {
      const reqArr = getFoldersBreadcrumbs(id, treeItem.childrenArr);

      if (reqArr?.length) {
        return reqArr;
      }
    }
  }
};

export const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

export const useElementSize = (element) => {
  const [size, setSize] = useState([0, 0]);

  useLayoutEffect(() => {
    const updateSize = () => {
      setSize([element?.offsetWidth, element?.offsetHeight]);
    };

    window.addEventListener('resize', updateSize);

    updateSize();

    return () => window.removeEventListener('resize', updateSize);
  }, [element]);

  return size;
};

export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const checkPremium = (subscription) => {

  const premiumUser = subscriptionType.premium;
  const blockedUser = subscriptionType.blocked;
  const trialUser = subscriptionType.trial;

  return subscription === premiumUser || subscription === blockedUser || subscription === trialUser;
};

export const roundUp = (number) => {
  const arrayNumber = number.toString().split("");
  const pointArrayNumber = arrayNumber.indexOf(".");

  return pointArrayNumber !== -1 ? arrayNumber.slice(0, pointArrayNumber + 3).join("") : number;
};

export const showToast = (isSuccess, text) => {

  toast((t) => (
    <Toast
      {...t}
    >
      <ManagerToast isSuccess={isSuccess} text={text} />
    </Toast>
  ),
    {
      duration: 2000,
    }
  );
};

export const calculationQuickInfo = (baseObject, newObject, mathOperation) => {

  let result = null;

  if (baseObject) {
    result = baseObject.map((baseEl) => {

      let value = null;
      let unit = null;

      newObject.forEach((newEl) => {
        if (baseEl.name === newEl.name) {
          value = newEl.value;
          unit = newEl.unit;
        }
      })

      return { ...baseEl, value: mathOperation === "plus" ? baseEl.value + value : baseEl.value - value, unit: baseEl.unit ? baseEl.unit : unit };
    })
  } else {
    result = newObject;
  }

  return result;
};

export const dragAndDropElement = (element, movableElement) => {

  element.style.zIndex = 1000;
  element.style.position = 'absolute';

  movableElement = movableElement ? movableElement : element

  movableElement.onmousedown = (e) => {
    const coords = getCoords(element);
    const shiftX = e.pageX - coords.left;
    const shiftY = e.pageY - coords.top;

    document.onmousemove = (e) => {
      element.style.left = e.pageX - shiftX + 'px';
      element.style.top = e.pageY - shiftY + 'px';
      element.style.right = 'auto';
    };
  }

  movableElement.onmouseup = () => {
    document.onmousemove = null;
  };

  const getCoords = (elem) => {
    let box = getBounding(elem);
    return {
      top: box.top + window.scrollY,
      left: box.left + window.scrollX
    };
  }
};

export const getColumnType = (value) => {
  switch (value) {
    case valueTypes.text:
    case valueTypes.customText:
    case valueTypes.proText:
    case valueTypes.customLink:
    case valueTypes.proLink:
    case valueTypes.customEnumMulty:
    case valueTypes.customEnumSingle:
    case valueTypes.proEnumMulty:
    case valueTypes.proEnumSingle:
      return columnDataType.text
    case valueTypes.date:
    case valueTypes.customDate:
    case valueTypes.proDate:
      return columnDataType.date
    case valueTypes.number:
    case valueTypes.customNumber:
    case valueTypes.proNumber:
      return columnDataType.number
    case valueTypes.customBool:
    case valueTypes.proBool:
      return columnDataType.checkbox
    default:
      return "default"
  }
};


export const generateColor = (positionObj) => {

  if (positionObj.verticalIndex === null || positionObj.horizontalIndex === null) {
    positionObj.verticalIndex = 0
    positionObj.horizontalIndex = 0
    return COLOR_PALETTE[positionObj.verticalIndex][positionObj.horizontalIndex]
  }

  positionObj.verticalIndex = positionObj.verticalIndex + 1

  if (positionObj.verticalIndex >= COLOR_PALETTE.length) {
    positionObj.verticalIndex = 0

    positionObj.horizontalIndex = positionObj.horizontalIndex + 1
    if (positionObj.horizontalIndex >= COLOR_PALETTE[positionObj.verticalIndex].length) {
      positionObj.horizontalIndex = 0
    }
  }

  return COLOR_PALETTE[positionObj.verticalIndex][positionObj.horizontalIndex]
};

export const getUniqueColor = (uniqueColorsData, currentValue) => {

  if (!uniqueColorsData?.store[currentValue]) {
    const positionObj = uniqueColorsData?.positionObj
    let currentColor = generateColor(positionObj);

    return (uniqueColorsData.store[currentValue] = currentColor);
  }

  return uniqueColorsData?.store[currentValue];
};
export const ObjectFilterByKeys = ({ object, keys }) => {
  if (!keys) {
    return;
  }
  const filteredObj = Object.entries(object)
    .filter(([key]) => keys.includes(key))
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

  return filteredObj;
};

export const ObjectDeleteByKey = ({ object, keyToDelete }) => {
  const currentObjectCopy = { ...object };
  const keys = Object.keys(currentObjectCopy);
  const filteredKeys = keys.filter(key => key !== keyToDelete);
  const newObject = {};

  filteredKeys.forEach(key => {
    newObject[key] = currentObjectCopy[key];
  });

  return newObject;
};

export const isNumeric = (str) => {
  if (typeof str != "string") {
    return !!parseFloat(str)
  };
  return !isNaN(str) && !isNaN(parseFloat(str));
}

export const transformCustomColumnsDtoToData = (customColumnsDto) => {

  const customColumns = {}

  for (const key in customColumnsDto) {
    const currentColumnSchemeDto = customColumnsDto[key]

    const currentTabId = currentColumnSchemeDto.advanceTabActive ? conditionTabId.advance : conditionTabId.basic
    const customColumn = {
      columnCondition: currentColumnSchemeDto.columnCondition,
      currentTree: JSON.parse(currentColumnSchemeDto.currentTree),
      currentTabId,
      functionValue: currentColumnSchemeDto.functionValue,
      newColumnName: currentColumnSchemeDto.newColumnName,
      newColumnKey: currentColumnSchemeDto.newColumnKey,
      variables: Object.values(currentColumnSchemeDto.variables)
    }

    customColumns[key] = customColumn
  }

  return customColumns
}

export const createTemplateSettingsDto = (templateSettings) => {
  const tableColumnsWithOutExistingValue = templateSettings.tableColumns.map((column) => {
    return { ...column, existingValue: [] }
  })

  return {
    ...templateSettings,
    tableColumns: tableColumnsWithOutExistingValue,
  }
}

export const parseTemplateSettingsDto = async (templateSettings) => {

  if (!templateSettings) {
    return { ...initTemplateSettings, temporarySetting: initTemporarySetting }
  }

  const filterByExistingPredictValue = (conditions, existingValue) => {
    const updatedConditions = []


    conditions?.forEach((condition) => {
      const conditionKey = condition.selectedOption.key
      if (conditionKey !== conditionsType.predictValue) {
        return updatedConditions.push(condition)
      }
      const filteredInputsDataArray = condition.inputsDataArray?.filter((value) => existingValue.includes(value))
      const newPredictCondition = { ...condition, inputsDataArray: filteredInputsDataArray }
      return updatedConditions.push(newPredictCondition)
    })

    return updatedConditions
  }

  let propertiesData = {}
  const getPropertiesData = async (propertyName) => {
    if (!propertiesData[propertyName]) {
      propertiesData[propertyName] = await propertyInfo(propertyName)
    }
  }
  await Promise.all(templateSettings.properties?.map((name) => getPropertiesData(name)))

  const tableColumnsWithExistingValue = templateSettings.tableColumns?.map((column) => {
    const propertyName = column.metaData.name
    const currentExistingValue = propertiesData[propertyName]?.values ?? []

    const currentSelectedFilters = filterByExistingPredictValue(column.settingsItems[ItemsTypeEnum.filters], currentExistingValue)
    const currentSelectedColors = filterByExistingPredictValue(column.settingsItems[ItemsTypeEnum.colors], currentExistingValue)

    const updatedSelectedValue = {
      [ItemsTypeEnum.filters]: currentSelectedFilters,
      [ItemsTypeEnum.colors]: currentSelectedColors,
    }

    return { ...column, existingValue: currentExistingValue, settingsItems: updatedSelectedValue }
  })

  return {
    ...templateSettings,
    tableColumns: tableColumnsWithExistingValue,
    temporarySetting: initTemporarySetting
  }
}

export const createCustomColumnsDto = (customColumns) => {

  const customColumnsDto = {}

  for (const key in customColumns) {
    const currentColumnScheme = customColumns[key]

    const advanceTabActive = currentColumnScheme.currentTabId === conditionTabId.advance

    const schemeToDB = {
      columnCondition: currentColumnScheme.columnCondition,
      currentTree: JSON.stringify(currentColumnScheme.currentTree),
      advanceTabActive,
      functionValue: currentColumnScheme.functionValue,
      newColumnName: currentColumnScheme.newColumnName,
      newColumnKey: currentColumnScheme.newColumnKey,
      variables: { ...currentColumnScheme.variables }
    }

    customColumnsDto[key] = schemeToDB
  }

  return customColumnsDto
}

const getKeyByValue = (object, value) => {
  return Object.keys(object).find(key => object[key] === value);
};

export const createConditionalFormattingDto = (customColor) => {
  if (!customColor?.colorSchemeType) {
    return null;
  }
  const dtoColorConditions = customColor?.colorSchemeConditionsData?.conditions.map((condition) => {
    return ({
      color: condition.color,
      type: conditionTypes[condition.type],
      inputsDataArray: [...condition.inputsDataArray],
    })
  })

  const isGradientTabActive = colorSchemeType.gradient === customColor?.colorSchemeType
  const newColorDto = {
    colorColumnKey: customColor.colorColumnKey,
    colorColumnType: valueTypes[customColor.colorColumnType],
    conditions: dtoColorConditions,
    colorSchemeGradientData: { ...customColor.colorSchemeGradientData },
    gradientTabActive: isGradientTabActive,
  }

  return newColorDto
}
export const transformConditionalFormattingDtoToData = (conditionalFormattingDto) => {
  if (!conditionalFormattingDto) {
    return null
  }
  const conditionsToData = conditionalFormattingDto?.conditions.map((condition) => {
    return ({
      color: condition.color,
      type: getKeyByValue(conditionTypes, condition.type),
      inputsDataArray: condition.inputsDataArray,
    })
  })
  const colorSchemeTypeValue = conditionalFormattingDto?.gradientTabActive ? colorSchemeType.gradient : colorSchemeType.conditionalColor
  const newDataColor = {
    colorColumnKey: conditionalFormattingDto?.colorColumnKey,
    colorColumnType: getKeyByValue(valueTypes, conditionalFormattingDto?.colorColumnType),
    colorSchemeConditionsData: {
      conditions: conditionsToData,
    },
    colorSchemeGradientData: conditionalFormattingDto.colorSchemeGradientData,
    colorSchemeType: colorSchemeTypeValue
  }

  return newDataColor
}

export const combineRefsIntoOne = (ref1, ref2) => (element) => {
  if (typeof ref1 === 'function') {
    ref1(element);
  } else if (ref1) {
    ref1.current = element;
  }

  if (typeof ref2 === 'function') {
    ref2(element);
  } else if (ref2) {
    ref2.current = element;
  }
};

export const sortArrayByDateKey = (data, key, dateFormat = 'yyyy/MM', sortOrder = 'asc') => {
  if (!Array.isArray(data) || !key) {
    return data;
  }

  const now = new Date();
  const compareFn = sortOrder === 'asc' ? compareAsc : compareDesc;

  return data.sort((a, b) => {
    const dateLeft = parseDate(a[key], dateFormat, now);
    const dateRight = parseDate(b[key], dateFormat, now);
    return compareFn(dateLeft, dateRight);
  });
}

export const parseDate = (value, dateFormat, fallback) => value ? parse(value, dateFormat, fallback) : fallback;
export const clamp = (val, min, max) => Math.min(Math.max(val, min), max);

export const lerp = (a, b, t) => a + (b - a) * t;

export const invLerp = (a, b, v) => (b === a ? 0 : (v - a) / (b - a));

export const formatDateRu = (date) => {
  try {
    return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch {
    return '';
  }
};

export const addDays = (base, days) => {
  const d = new Date(base);
  d.setDate(d.getDate() + days);
  return d;
};

export const addMonths = (base, months) => {
  const d = new Date(base);
  d.setMonth(d.getMonth() + months);
  return d;
};
